<h3 class="with-icon mat-h3 pointer view-project-details" (click)="displaySelectDialog()">
    
    <span class="mat-body-strong mat-body-2">{{project.reference()}}</span> - {{project.projTitle}}
    <button mat-button><mat-icon *ngIf="project.allocatedTo().length>0" aria-label="Pre-allocated" matTooltip="Pre-allocated" >not_interested &nbsp;</mat-icon></button>
    <button *ngIf="project.allocatedTo().length<1" mat-button><mat-icon  matTooltip="View details" >visibility</mat-icon></button>

</h3>